import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AlertWarningModule,
  ButtonModule,
  CheckboxStandardModule,
  HelpIconModule,
  InputModule
} from '@com-delta-idp/mnx-ui-kit';
import { LoginFooterModule } from '../../shared/login-footer/login-footer.module';
import { LoginHeaderModule } from '../../shared/login-header/login-header.module';
import { LogoHeaderModule } from '../../shared/logo-header/logo-header.module';
import { UnlockYourAccountComponent } from './unlock-your-account.component';

@NgModule({
  declarations: [UnlockYourAccountComponent],
  imports: [
    CommonModule,
    LoginFooterModule,
    LogoHeaderModule,
    LoginHeaderModule,
    InputModule,
    CheckboxStandardModule,
    HelpIconModule,
    ButtonModule,
    ReactiveFormsModule,
    AlertWarningModule
  ],
  exports: [UnlockYourAccountComponent]
})
export class UnlockYourAccountModule {}
